'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChatMinimizeIcon = function (_Component) {
    _inherits(ChatMinimizeIcon, _Component);

    function ChatMinimizeIcon(props) {
        _classCallCheck(this, ChatMinimizeIcon);

        var _this = _possibleConstructorReturn(this, (ChatMinimizeIcon.__proto__ || Object.getPrototypeOf(ChatMinimizeIcon)).call(this, props));

        _this.state = {
            messageCount: 0,
            visibility: 'DISPLAYMODE_NORMAL',
            newMessagesCount: 0
        };
        return _this;
    }

    _createClass(ChatMinimizeIcon, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({
                messageCount: 0,
                newMessagesCount: 0
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var messageCount = this.state.messageCount;
            var visibilitystatus = this.state.visibility;
            var newMessagesCount = this.state.newMessagesCount;
            var count = 0;

            nextProps.messages.map(function (message) {
                if (message.action === "message_receive") {
                    count++;
                }
                return null;
            });

            if (visibilitystatus === 'DISPLAYMODE_ICON' && count > messageCount) {
                newMessagesCount++;
            }

            if (nextProps.defaultChatBoxMode === 'DISPLAYMODE_NORMAL' || nextProps.defaultChatBoxMode === 'DISPLAYMODE_HIDE') {
                newMessagesCount = 0;
            }

            this.setState({
                visibility: nextProps.defaultChatBoxMode,
                messageCount: count,
                newMessagesCount: newMessagesCount
            });

            console.log("Component next prop: newmsgCount", this.state.newMessagesCount, " msgcount: ", this.state.messageCount);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            // console.log("New Component: " + this.state.messageCount + " " + this.state.newMessagesCount + " " + this.state.visibility)

            // let chatIcon = this.state.visibility ?
            //      : null

            var notificationBadge = this.props.unReadMessageCount > 0 ? _react2.default.createElement(
                'span',
                { className: 'chat_icon_notification_badge' },
                this.props.unReadMessageCount
            ) : null;

            return _react2.default.createElement(
                'div',
                { className: 'chat_icon_container' },
                _react2.default.createElement('button', {
                    type: 'button', onClick: function onClick(e) {
                        e.preventDefault();
                        _this2.props.showChatBox();
                    },
                    className: 'btn jm_chat_min_icon fa fa-comments fa-2x chatIcon' }),
                notificationBadge
            );
        }
    }]);

    return ChatMinimizeIcon;
}(_react.Component);

ChatMinimizeIcon.defaultProps = {
    messages: []
};

exports.default = ChatMinimizeIcon;


// WEBPACK FOOTER //
// ../chat/lib/components/chatbox/chatminimizedicon.js